var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ebso-info-banner"},[_c('div',{staticClass:"ebso-info-banner__inner"},[_c('strong',[_vm._v(_vm._s(_vm.$t('ebsoInfoRow.text')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }